import loadable from '@loadable/component';

export const OrgDashboardCheckoutBillingAddressContainerLoadable = loadable(
  () => import('./OrgDashboardCheckoutBillingAddressContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardCheckoutBillingAddressContainer,
  },
);
